import React, { useMemo } from 'react'
import { Checkbox, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '~/Store'
import { getIsLoadingProductClaims, getProductClaims } from '~/Store/ApiKey'

interface Props {
  productId: string
  servicePrincipalId: string
  selectedClaimIds: string[]
  onToggleClaim: (claimId: string, checked: boolean) => void
  onDeselectAll: () => void
}

export const ProductPermissions = ({
  productId,
  servicePrincipalId,
  selectedClaimIds,
  onToggleClaim,
  onDeselectAll,
}: Props) => {
  const { t } = useTranslation()
  const key = `${servicePrincipalId}:${productId}`
  const claims = useAppSelector(getProductClaims(key))
  const isLoading = useAppSelector(getIsLoadingProductClaims(key))

  // Sắp xếp theo bảng chữ cái (claimType:claimValue) để dễ dò tìm trong danh sách dài.
  const sortedClaims = useMemo(
    () =>
      [...(claims || [])].sort((a, b) =>
        `${a.claimType}:${a.claimValue}`.localeCompare(
          `${b.claimType}:${b.claimValue}`,
        ),
      ),
    [claims],
  )

  return (
    <Spin spinning={isLoading}>
      {!!claims?.length && (
        <div style={{ textAlign: 'right', marginBottom: '8px' }}>
          <a onClick={onDeselectAll}>{t('admin.akDeselectAll')}</a>
        </div>
      )}
      {sortedClaims.map(claim => (
        <div key={claim.productClaimId} style={{ marginBottom: '8px' }}>
          <Checkbox
            checked={selectedClaimIds.includes(claim.productClaimId)}
            onChange={evt =>
              onToggleClaim(claim.productClaimId, evt.target.checked)
            }
          >
            <code>
              {claim.claimType}:{claim.claimValue}
            </code>
          </Checkbox>
        </div>
      ))}
      {!isLoading && claims?.length === 0 && <span>{t('admin.akNoPermissions')}</span>}
    </Spin>
  )
}
